module.exports = __webpack_public_path__ + "static/media/star.4893a554.svg";